import { render, staticRenderFns } from "./OrderViewPanel.vue?vue&type=template&id=6afef3c5"
import script from "./OrderViewPanel.vue?vue&type=script&lang=js"
export * from "./OrderViewPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderViewPanel.vue?vue&type=style&index=0&id=6afef3c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports